import { render, staticRenderFns } from "./FoliaSampleRequest.vue?vue&type=template&id=905605c6&"
import script from "./FoliaSampleRequest.vue?vue&type=script&lang=js&"
export * from "./FoliaSampleRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports